// eslint-disable-next-line
/* eslint-disable */
import React, { Component } from 'react';
import RootRouter from './RootRouter'
import * as util from './js/util.js'
import { withRouter } from "react-router-dom"
import { Route, Switch } from "react-router-dom"
import * as appConfig from './js/config';
import CurrentRaceInfo from './page/CurrentRaceInfo.js'


class App extends Component {
  
	constructor(props) {
		super(props);

		this.state = {
	  
		};
	
		util.loadSession();	
		var params = util.getUrlVars()
		window.urlParams = params;
		
		window.info.config = appConfig;
		/*var lang = params.lang ? params.lang : null	
		if ( lang == null ){		
			lang = (window.info && window.info.lang) ? window.info.lang : wording.ENGLISH
		}		
		if (window.info ){
			window.info.lang = lang
		}else{
			window.info = {}	
			window.info.lang = lang
    }
    
		wording.setInitLang(lang)
		*/
		/*if ( this.props.location.search != null && this.props.location.search.length > 0 ){
			this.props.history.replace(this.props.location.pathname)
		}*/
		/*if (window.info.errMsg == null){
			wording.getWording('/wording/Common/ErrorMessage.json').then((wordingJson) => {
				window.info.errMsg = wordingJson;				
				util.saveSession('VC');
			});
		}*/
		util.saveSession('A')	
	}

	
	componentDidMount() {	
	}

	componentWillUnmount() {
	}


	render() {
//		<Route path={process.env.PUBLIC_URL} render={(props) => (
		return (
			<div id="webapp" >
				<Switch>
					<Route path={window.info.config.pathname + "/info.html"} render={(props) => (
						<React.Fragment>
							<CurrentRaceInfo {...props} rootHideShowLoading={this.hideShowLoading} />
						</React.Fragment>
					)} />
					
					<Route render={(props) => (
							<RootRouter {...props} />
					)} />
				</Switch>
			</div>
		);
	}

}

export default withRouter(App);
